module.exports = __webpack_public_path__ + "static/media/university-of-virginia-2.f9ee666e.svg";